import { Component, OnInit, Optional, Inject, Input } from '@angular/core';
import { IAppDataStore } from '@pershing/pershing-core';
import { ExchangeAgreementConfirmLaterDialogComponent } from '../ExchangeAgreementConfirmlaterDialog/exchange-agreement-confirmlater-dialog.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { TradingService, TradingEntitlements } from '@pershing/trading-common';

@Component({
  selector: 'exchange-agreement-nsdaq',
  templateUrl: './exchange-agreement-nsdaq.component.html'
})
export class ExchangeAgreementNSDAQComponent implements OnInit {
  @Input() platform: string;
  @Input() public tradingEntitlements: TradingEntitlements = null;

  newwindow: any;
  selected = '';
  subsciberName: string;
  curDate: any;
  form: FormGroup;
  isSubmitted: boolean = false;
  deviceType: string = 'desktop';
  constructor(
    private dialog: MatDialog,
    private tradingService: TradingService, private appDataStore: IAppDataStore, @Optional() @Inject('AppSettings') private appSettings: any) {
    if (!!appSettings.deviceType) {
      this.deviceType = appSettings.deviceType;
    }
  }
  ngOnInit() {
    this.curDate = new Date();
    this.form = new FormGroup({
      subscriberName: new FormControl('', Validators.required),
      subscriberSignature: new FormControl('', Validators.required),
      agentName: new FormControl(),
      agentTitle: new FormControl(),
      otherAgentTitle: new FormControl(),
      agreementIdTwo: new FormControl('02')
    });
  }

  onFormSubmit() {
    this.isSubmitted = true;
    if (this.form.valid) {
      let formdata = this.form.value;
      this.appDataStore.put('NASDAQDATA', formdata);
      this.onOpra();
    }
  }

  showCancelDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.minWidth = '250px';
    dialogConfig.disableClose = true;
    this.dialog.open(ExchangeAgreementConfirmLaterDialogComponent, dialogConfig);
  }

  onOpra() {
    this.tradingService.setExchangeAgreementDialogState('exchangeagreementopra');
  }

  popUpWindow(name: any, section: any) {
    const tempUrl = '/nxi/disclosure/brokeragedisclosure/exchangeagreements/nasdaqomxterms#' + section;
    this.newwindow = window.open(tempUrl, name, 'width=700,height=500,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=0,left=0,top=0');
    if (!this.newwindow.closed) { this.newwindow.focus(); }
  }
}
